import { render, staticRenderFns } from "./e-tabs.vue?vue&type=template&id=4f853ea2&scoped=true"
import script from "./e-tabs.vue?vue&type=script&lang=js"
export * from "./e-tabs.vue?vue&type=script&lang=js"
import style0 from "./e-tabs.vue?vue&type=style&index=0&id=4f853ea2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f853ea2",
  null
  
)

export default component.exports